var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkuTileConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71429 38H39.2857C40.7848 38 42 37.3284 42 36.5C42 35.6716 40.7848 35 39.2857 35H6.71429C5.21523 35 4 35.6716 4 36.5C4 37.3284 5.21523 38 6.71429 38Z",
    fill: "#9A5184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71429 33H39.2857C40.7848 33 42 31.433 42 29.5C42 27.567 40.7848 26 39.2857 26H6.71429C5.21523 26 4 27.567 4 29.5C4 31.433 5.21523 33 6.71429 33Z",
    fill: "#F66127"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71429 19H39.2857C40.7848 19 42 18.3284 42 17.5C42 16.6716 40.7848 16 39.2857 16H6.71429C5.21523 16 4 16.6716 4 17.5C4 18.3284 5.21523 19 6.71429 19Z",
    fill: "#9A5184"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71429 14H39.2857C40.7848 14 42 12.433 42 10.5C42 8.567 40.7848 7 39.2857 7H6.71429C5.21523 7 4 8.567 4 10.5C4 12.433 5.21523 14 6.71429 14Z",
    fill: "#F66127"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkuTileConfig);
export default __webpack_public_path__ + "static/media/skuTileConfig.0fffca0c614d1d426ce6e38c98257fca.svg";
export { ForwardRef as ReactComponent };